<script>
    import {
        Block,
        BlockTitle,
        Link,
        Tabs,
        Tab
    } from 'framework7-svelte';
    import { onMount } from 'svelte';
    onMount(() => {
    
    })
    </script>
    <style>
    
    </style>
    <BlockTitle >Tutoriales del Sistema de Alerta Temprana de Incendios Forestales</BlockTitle>
    <Block strong mediumInset style="text-align: justify;">
        <strong>Presentación del nuevo sitio web del Sistema de Alerta Temprana de Incendios Forestales de la CONABIO.</strong>

    <p>
        <Link href="https://www.facebook.com/CONABIO/videos/461620335423601/?mibextid=zDhOQc" target="_blank" external>
            <img src="static/png/presentacionSatif.png" alt="Presentación Facebook" width="595px;"/>
        </Link>
            
    </p>
        <p>
            <strong>Presentan:  </strong>
            <br> Dr. José Sarukhán - CONABIO
            <br> Terry Miller - USAID México
            <br> Liz Mayhew - Cooperación Forestal México - Estados Unidos
        </p>
        

    </Block>
    